// src/features/staff/pages/ProfilePage/components/UserCard.jsx
import React from 'react';
import { useTranslation } from 'react-i18next';
import {
  Card,
  CardContent,
  Typography,
  Chip,
  Stack,
  Box,
  Divider,
} from '@mui/material';
import {
  Business as BusinessIcon,
  Security as SecurityIcon,
  CheckCircle as CheckCircleIcon,
  Block as BlockIcon,
} from '@mui/icons-material';
import ProfilePicture from '../../../../../components/common/ProfilePicture';

export default function UserCard({ profileData }) {
  const { t } = useTranslation(['staff', 'common']);

  return (
    <Card sx={{ height: "100%" }}>
      <CardContent sx={{ height: "100%" }}>
        <Stack spacing={3} alignItems="center">
          <ProfilePicture
            profilePictureFileId={profileData?.profile_picture_file_id}
            name={profileData?.name}
            size={120}
            imageSize="128x128"
            color={profileData?.color}
          />

          <Box textAlign="center">
            <Typography variant="h5" fontWeight="bold" gutterBottom>
              {profileData.name}
            </Typography>
            
            <Chip
              icon={profileData.is_active ? <CheckCircleIcon /> : <BlockIcon />}
              label={profileData.is_active ? t('staff:status.active') : t('staff:status.inactive')}
              size="small"
              color={profileData.is_active ? 'success' : 'warning'}
              variant="outlined"
            />
          </Box>

          <Divider sx={{ width: '100%' }} />

          {/* Department Info */}
          <Box width="100%">
            <Box display="flex" alignItems="center" gap={1} mb={1}>
              <BusinessIcon fontSize="small" color="primary" />
              <Typography variant="subtitle2" fontWeight="medium">
                {t('staff:profile.department')}
              </Typography>
            </Box>
            <Typography variant="body1" color="text.secondary" ml={4}>
              {profileData.department?.name || t('common:labels.unknown')}
            </Typography>
          </Box>

          {/* Role Count */}
          <Box width="100%">
            <Box display="flex" alignItems="center" gap={1} mb={1}>
              <SecurityIcon fontSize="small" color="primary" />
              <Typography variant="subtitle2" fontWeight="medium">
                {t('staff:profile.roles')}
              </Typography>
            </Box>
            <Typography variant="body1" color="text.secondary" ml={4}>
              {t('staff:profile.roles_count', { count: profileData.roles?.length || 0 })}
            </Typography>
          </Box>
        </Stack>
      </CardContent>
    </Card>
  );
}